import {Product, ProductPayload} from "./product";
import { Storage } from '@capacitor/storage';
import {ToastController} from "ionic-angular";
import {Coupon} from "./coupon";
import {Menu, MenuPayload} from "./menu";
import {COUPON_COST_REDUCTION} from "../constants/config";
import {StorageService} from "../services/storage.service";
import {ProductSpecial} from "./product_special";

export class Cart {
  public products : Product[] = [];
  public coupons : Coupon[] = [];
  public shippingCost : number;
  constructor(private storage : StorageService, private toastCtrl : ToastController){

  }

  clear(){
    this.products = [];
    this.coupons = [];
    this.shippingCost = 0;
  }

  getGrandTotal(coupons = false){
    let total = 0;
    this.products.forEach((product : Product) => {
      total += product.getCartPrice();
    });

    if (coupons){
      return total -= COUPON_COST_REDUCTION;
    }

    // FIX JAVASCRIPT ROUNDING ERROR
    return Math.round(total * 100) / 100;
  }

  getGrandTotalWithShipping(shipping){
    if (!shipping.required){
      return this.getGrandTotal();
    }
    return this.getGrandTotal() + shipping.cost;
  }

  getGrandTotalFormatted(coupons = false){
    let price = this.getGrandTotal(coupons);
    if (price.toString().indexOf(".") > -1){
      let suffix = price.toString().split(".");
      if (suffix[1].length == 1){
        suffix[1] = suffix[1] + "0";
      }
      return suffix.join(",");
    }
    return price.toString() + ",00";
  }

  replaceProduct(product : Product, withProduct : Product){
      this.removeProduct(product);
      /*this.addProduct(withProduct,{added: [],
      removed: []}); */
  }

  setCoupons(couponGroup : Coupon[]){
    this.coupons = couponGroup;
  }


  getOrderPayload(){
    const result : IOrderPayload = {};
    result.products = this.products.map(prod => prod.serialize());
    return result;
  }

  addProduct(product : Product|ProductSpecial, opts){
    product.setIdentifier();
    product.addedIngredients = opts.added;
    product.removedIngredients = opts.removed;
    product.message = opts.message;
    let inCart = false;
    this.products = this.products.map((addedProduct : Product) => {
      // check if title is the same
      if (addedProduct.name == product.name && addedProduct.number == product.number){
        // check size:
        if (addedProduct.meta.sizeIndex == product.meta.sizeIndex) {
          // check if added products are equal
          const primaryAddedIngredientsIdentifier = addedProduct.addedIngredients.sort().map(ingredient => ingredient.id).join("");
          const secondaryAddedIngredientsIdentifier = product.addedIngredients.sort().map(ingredient => ingredient.id).join("");
          const primaryRemovedIngredientsIdentifier = addedProduct.removedIngredients.sort().map(ingredient => ingredient.id).join("");
          const secondaryRemovedIngredientsIdentifier = product.removedIngredients.sort().map(ingredient => ingredient.id).join("");

          if (primaryAddedIngredientsIdentifier == secondaryAddedIngredientsIdentifier && primaryRemovedIngredientsIdentifier == secondaryRemovedIngredientsIdentifier){
            if(product.type === "product-special" && addedProduct.type ==="product-special"){
              let p1: ProductSpecial = <ProductSpecial> product;
              let p2: ProductSpecial = <ProductSpecial><unknown>addedProduct;
              if(JSON.stringify(p1.entries) !== JSON.stringify(p2.entries)) return addedProduct;
            }

            if(product.message !== addedProduct.message) return addedProduct;

            addedProduct.quantity += 1;
            inCart = true;
          }
        }
      }

      return addedProduct;
    });

    function arrayEquals(a, b) {
      return Array.isArray(a) &&
        Array.isArray(b) &&
        a.length === b.length &&
        a.every((val, index) => val === b[index]);
    }

    if (!inCart)
      this.products.push(product as any);

    this.syncStorage();

    this.toastCtrl.create({
      message: `${product.name.replace('&amp;', '&')} hinzugefügt`,
      duration: 1500,
      position: "top"
    }).present();

    product.getCartPrice();
  }

  syncStorage(){
    this.storage.set("cart:products", this.serialize());
  }

  serialize(){
    return this.products.map((product : Product) => {
      return [product.getPayload(), product.getCategory()];
    });
  }

  getProducts(){
    return this.products;
  }


  getProductsQuantity(){
    let products = this.getProducts();
    let sum = 0;

    products.forEach(function(product){
      sum+= product.quantity;
    });

    return sum;
  }

  deserialize(payloads : Array<any>){
    if (!payloads){ return []; }
    return payloads.map((payload : Array<ProductPayload|Object>) => {
      const product = new Product(payload[0] as ProductPayload, new Menu(payload[1] as MenuPayload));
      product.setIdentifier();
      return product;
    });
  }

  removeProduct(product : Product){
    this.products = this.products.filter((b) => {
      return (product.identifier !== b.identifier);
    });

    this.toastCtrl.create({
      message: `${product.name} entfernt`,
      duration: 2000
    }).present();

    this.syncStorage();
  }
}



interface IOrderPayload {
  products?;
  cart?  : Cart;
  coupons?
  shippingAddress?;
  deliveryMethod?;
  paymentMethod?;
  paymentIntent?;
  mov?;
  message?
  orderType?
}



// WEBPACK FOOTER //
// ./src/app/classes/cart.ts